import { render, staticRenderFns } from "./MenuTreeItem.vue?vue&type=template&id=6b9a7f53&scoped=true&"
import script from "./MenuTreeItem.vue?vue&type=script&lang=ts&"
export * from "./MenuTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./MenuTreeItem.vue?vue&type=style&index=0&id=6b9a7f53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a7f53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VChip,VIcon})
